module.exports = __webpack_public_path__ + "static/media/target-amount-calc.2cee9154.svg";